import { render, staticRenderFns } from "./CursosHomeCarousel.vue?vue&type=template&id=f2384d32&scoped=true&"
import script from "./CursosHomeCarousel.vue?vue&type=script&lang=js&"
export * from "./CursosHomeCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2384d32",
  null
  
)

export default component.exports